export default {
  home: 'Home',
  introduce: '',
  policy: '',
  switchLang: 'Language',
  openMerchants: 'Become a seller',
  login: 'Login',
  sellerCenter: 'Seller Center',
  logOut: 'Log Out',
  loginError: 'Store Information not found, Please log in again',
  noStore: 'Store Information not found',
  app: 'Seller APP',
  helpCenter: 'Registration Guide'
}
